import React from "react";
import { useNavigate } from "react-router-dom";
import { useCampaign } from "./CampaignContext";

export default function CampaignDashboard() {
  const nav = useNavigate();
  const { current, saveCampaign, error } = useCampaign();

  const handleSave = async () => {
    await saveCampaign();
    alert("Campaign saved.");
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>Campaign Dashboard</h2>

      {error ? <div style={{ color: "crimson", marginTop: 8 }}>{error}</div> : null}

      {!current?.settlementName ? (
        <div style={{ marginTop: 12, opacity: 0.85 }}>
          No campaign loaded. Go to <button onClick={() => nav("/setup")}>New Campaign</button> or{" "}
          <button onClick={() => nav("/load")}>Load Campaign</button>.
        </div>
      ) : (
        <>
          <div style={{ marginTop: 12 }}>
            <div><b>Settlement:</b> {current.settlementName}</div>
            <div><b>Campaign Type:</b> {current.campaignType || "-"}</div>
            <div><b>Monsters:</b> {(current.monsters || []).join(", ") || "-"}</div>
            <div><b>Pillars:</b> {(current.pillars || []).join(", ") || "-"}</div>
            <div><b>Survivors:</b> {(current.survivors || []).length}</div>
          </div>

          <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
            <button onClick={handleSave}>Save</button>
            <button onClick={() => nav("/setup")}>Go to Setup</button>
            <button onClick={() => nav("/settlement")}>Go to Settlement</button>
          </div>
        </>
      )}
    </div>
  );
}